/**
 * `sizes` presets describing how wide a `<SanityImage>` renders at each breakpoint.
 * The browser combines this with the `srcset` to download the smallest adequate file,
 * so keep them in sync with the layout that hosts the image.
 */
export const IMAGE_SIZES = {
  /** Product / service cards (max 330px wide on md+, 280px below). */
  card: '(min-width: 768px) 330px, 280px',
  /** Project cards in the 1/2/3-column grid next to the category sidebar. */
  projectCard: '(min-width: 1024px) 22vw, (min-width: 768px) 28vw, (min-width: 640px) 45vw, 90vw',
  /** Gallery masonry grid: 1 / 2 / 3 / 4 columns. */
  gallery: '(min-width: 1280px) 22vw, (min-width: 1024px) 28vw, (min-width: 640px) 42vw, 92vw',
} as const;
